import { UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import { TLineSchemaWithDiscount } from 'shared/types/dailyrent/dailyrent';

import { DailyrentDiscount } from '../../DailyrentDiscount';
import * as styles from '../BookingInfo.css';

export function Headline({ headLine }: { headLine: TLineSchemaWithDiscount | undefined }) {
  const showDiscount = headLine?.originalPrice && headLine?.discountPercent;

  if (!headLine || !headLine.text) {
    return null;
  }

  return (
    <div className={styles['section-heading']}>
      <UIHeading3>{headLine.text}</UIHeading3>
      {showDiscount && (
        <DailyrentDiscount originalPrice={headLine.originalPrice} discountPercent={headLine.discountPercent} />
      )}
      <UIHeading3>{headLine.value}</UIHeading3>
    </div>
  );
}
